import {BrowserModule} from '@angular/platform-browser';
import {ComponentFactoryResolver, LOCALE_ID, NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {HttpClient, HttpClientModule} from '@angular/common/http';
import {Routing} from './app.routing';
import {RealTimeModule} from './real-time/real-time.module';


import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {CommonModule} from './common/common.module';
// @ts-ignore
import {AppComponent} from './app.component';
import {ComponentLoaderService} from 'app/common/component-loader.service';
import {_defaultCity, CITY} from 'app/common/const';
import {environment} from 'environments/environment';
import {CITY_REGISTER} from 'app/cities/informo.loaders';

import {InformoModule} from 'app/cities/informo/informo.module';
import {HistoricModule} from './historic/historic.module';

export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
};

export const selectLoader = (resolver: ComponentFactoryResolver) => {
    const loader: any = CITY_REGISTER.find(c => c.id === environment.city).loader;
    return new loader(resolver);
};

export const selectCity = () => {
    const city: any = CITY_REGISTER.find(c => c.id === environment.city).metadata || _defaultCity;
    return city;
};

@NgModule({
    declarations: [
        AppComponent,
    ],
    imports: [
        BrowserModule,
        FormsModule,
        HttpClientModule,
        RouterModule,
        Routing,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            }
        }),
        CommonModule,
        RealTimeModule,
        HistoricModule,
        InformoModule,
    ],
    providers: [
        {
            provide: ComponentLoaderService,
            useFactory: selectLoader,
            deps: [ComponentFactoryResolver]
        },
        {provide: CITY, useFactory: selectCity},
        {provide: LOCALE_ID, useValue: 'en-US'}
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.informo.module.ts